var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFamilyShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1784 3H15.8815C15.8815 8.62948 11.318 13.1931 5.68848 13.1931V23.3162C5.68848 43.6325 26.0047 49 26.0047 49C26.0047 49 46.3209 43.6325 46.3209 23.3162V13.1931C40.6915 13.1931 36.1278 8.62948 36.1278 3H30.593",
    fill: "url(#paint0_linear_7240_24216)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2567 8.16844C29.0837 6.99553 27.182 6.99553 26.009 8.16844C24.836 6.99553 22.9344 6.99553 21.7615 8.16844C20.5886 9.34135 20.5886 11.2431 21.7615 12.4161L24.5671 15.2217L26.009 16.6636L30.2567 12.4161C31.4296 11.2431 31.4296 9.34135 30.2567 8.16844Z",
    fill: "#FF3D77"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2473 26.3342C30.2301 26.3342 28.5889 24.6932 28.5889 22.6763C28.5889 20.659 30.2301 19.0178 32.2473 19.0178C34.2646 19.0178 35.9058 20.659 35.9058 22.6763C35.9059 24.6933 34.2647 26.3342 32.2473 26.3342Z",
    fill: "#FBC8AD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1671 36.5364C30.1671 34.0606 28.1527 32.0465 25.6768 32.0465V31.832C26.9878 31.832 28.0544 30.7653 28.0544 29.4543C28.0544 28.9668 27.9077 28.4981 27.6301 28.099L27.5776 28.0235L27.6442 27.96C28.8905 26.7732 30.5252 26.1196 32.2472 26.1196C35.9292 26.1196 38.9248 29.1152 38.9248 32.7973C38.9248 33.8045 38.0743 34.7618 36.4651 35.5655C34.9188 36.3378 32.783 36.9199 30.2884 37.2486L30.1671 37.2646V36.5364Z",
    fill: "#45EB80"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6776 32.0465C24.2485 32.0465 23.0859 30.8836 23.0859 29.4542C23.0859 28.9219 23.246 28.4109 23.5488 27.9764C24.0332 27.2786 24.8291 26.8621 25.6776 26.8621C26.5265 26.8621 27.3225 27.2787 27.8071 27.9765C28.1098 28.4117 28.2698 28.9227 28.2698 29.4542C28.2698 30.8837 27.107 32.0465 25.6776 32.0465Z",
    fill: "#FBC8AD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6771 37.5413C24.0895 37.5413 22.5381 37.4428 21.0659 37.2486L20.9727 37.2363V36.5362C20.9727 33.9422 23.083 31.8318 25.6771 31.8318C28.2714 31.8318 30.382 33.9422 30.382 36.5362V37.2363L30.2888 37.2486C28.8166 37.4428 27.265 37.5413 25.6771 37.5413Z",
    fill: "#45CCFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0666 37.2486C18.5719 36.9199 16.4359 36.3379 14.8895 35.5655C13.2802 34.7618 12.4297 33.8046 12.4297 32.7973V32.69H12.431C12.4884 29.0571 15.4613 26.1196 19.1073 26.1196C20.8291 26.1196 22.4639 26.7732 23.7109 27.9599L23.7776 28.0235L23.7249 28.0991C23.4474 28.4974 23.3006 28.966 23.3006 29.4543C23.3006 30.7653 24.367 31.832 25.6777 31.832V32.0465C23.202 32.0465 21.1879 34.0606 21.1879 36.5364V37.2648L21.0666 37.2486Z",
    fill: "#FF844F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1072 26.3342C17.0902 26.3342 15.4492 24.6932 15.4492 22.6763C15.4492 20.659 17.0902 19.0178 19.1072 19.0178C21.1244 19.0178 22.7656 20.659 22.7656 22.6763C22.7656 24.6933 21.1244 26.3342 19.1072 26.3342Z",
    fill: "#FBC8AD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7240_24216",
    x1: 10.7675,
    y1: 51.76,
    x2: 32.2807,
    y2: 0.452233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#833BDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54FFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFamilyShield);
export default __webpack_public_path__ + "static/media/icon_family_shield.257ed1e03d28908cf39887c309cea410.svg";
export { ForwardRef as ReactComponent };